export const NotificationVI = {
    "notification":{
       "sendAll" : "Xem tất cả",
        "all" : "Tất cả",
        "process" : "Quy trình",
        "notification" : "Thông báo",
        "read" : "Đã đọc",
        "noRead" : "Chưa đọc",
        "viewAll": "Xem toàn bộ thông báo",
        "changeStatusAll": "Đánh dấu đã đọc tất cả",
        "404" : "Tài nguyên không tìm thấy trong hệ thống",
        "500" : "Không thể đăng nhập, Đã xảy ra sự cố khi giao tiếp với máy chủ, vui lòng thử lại sau.",
        loginFailed : "Sai tên người dùng hoặc mật khẩu. Vui lòng thử lại!",
        layoutNameFailed : "Không được để trống tên layout và thống kê cho cái gì ?",
        layoutRequest : "Phải gửi lên layout để hiển thị  ?",
        typeSalaryRequest : "Hình thức lương chưa nhập",
        totalSalaryRequest : "Số tiền của hình thức lương chưa nhập",
        benefitType : "Loại phụ cấp chưa nhập",
        totalSalaryBenefitRequest : "Số tiền của loại phụ cấp chưa nhập",
        "supportOnlyJpgPng" : "Bạn chỉ có thể tải lên tệp JPG/PNG!",
        "totalMaxFileSize" : "Tổng dung lượng các tệp không được lớn hơn 100mb",
     uploadMaxSize : "Không được upload ảnh quá 2MB"
    }
}
